import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Roles } from '../RoleConfig';
import { FaqService } from '../../faq/faq.service';

@Component({
  selector: 'lp2-contact-us-faqs',
  template: `
    <div class="main">
      <div class="container contact-us-page-container">
        <div class="row justify-content-center">
          <div *ngFor="let role of roles" class="col-6 profile-container">
            <div class="faq-container">
              <lp2-faq-container [faqs]="faqService.filteredArticles$ | async"></lp2-faq-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./contact-us-faqs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsFaqsComponent implements OnInit {
  roles = Roles;

  constructor(public faqService: FaqService) {}

  ngOnInit() {
    this.faqService.initFaqsAndFilters();
  }
}



// WEBPACK FOOTER //
// ./ts/app/contact-us/contact-us-page-faqs/contact-us-faqs.component.ts